import { render } from "./ProductSlotsTable.vue?vue&type=template&id=12c5fbe4&scoped=true&ts=true"
import script from "./ProductSlotsTable.vue?vue&type=script&lang=ts"
export * from "./ProductSlotsTable.vue?vue&type=script&lang=ts"

import "./ProductSlotsTable.vue?vue&type=style&index=0&id=12c5fbe4&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c5fbe4"]])

export default __exports__